import { CONFIG } from "../config";
import { logger } from "./logger";
import { parseJsonSafe } from "./json";

/**
 * Cleans address from history item data
 */
export function cleanAddress(historyItem) {
  try {
    let data = historyItem.data;
    //json parse data
    let dataParsed = parseJsonSafe(data, null);
    if (!dataParsed) {
      return "No geocode available";
    }

    let address = dataParsed.geocode;

    return address;
  } catch (e) {
    return "No geocode available" + e.message;
  }
}

/**
 * Converts millivolts to percentage based on device brand
 */
export function convertMvToPercent(
  mv = null,
  deviceBrand = null,
  addPercent = true
) {
  // Handle null, undefined, or NaN values
  if (mv === null || mv === undefined || isNaN(mv)) {
    return addPercent ? "N/A" : NaN;
  }

  // Convert to number if it's a string
  mv = Number(mv);

  // Double check after conversion
  if (isNaN(mv)) {
    // might be a string like "normal", if it is return that string
    return mv + (addPercent ? "%" : "");
  }

  //check if deviceBrand is full object for device or just the deviceBrand object
  if (deviceBrand && deviceBrand.deviceBrand) {
    deviceBrand = deviceBrand.deviceBrand;
  }

  // if mv is 2 or 3 digits, it might already be a percent, so return it
  if (mv.toString().length <= 3 && mv <= 100) {
    if (!addPercent) {
      return parseInt(mv);
    }

    return mv + "%";
  }

  //load full file content and continue conversion logic
  let batteryMaxMv =
    deviceBrand?.batteryMaxMV || CONFIG.defaultBatteryMaxMv || 4200;
  let batteryMinMv =
    deviceBrand?.batteryMinMV || CONFIG.defaultBatteryMinMv || 3200;

  // Validate that we have valid min/max values
  if (
    !batteryMaxMv ||
    !batteryMinMv ||
    isNaN(batteryMaxMv) ||
    isNaN(batteryMinMv)
  ) {
    logger.warn("Invalid battery min/max values:", {
      batteryMaxMv,
      batteryMinMv,
      deviceBrand,
    });
    return addPercent ? "N/A" : NaN;
  }

  // Ensure max > min to prevent division by zero
  if (batteryMaxMv <= batteryMinMv) {
    logger.warn("Battery max must be greater than min:", {
      batteryMaxMv,
      batteryMinMv,
    });
    return addPercent ? "N/A" : NaN;
  }

  //check if mv is above max, if so return 100%
  if (mv >= batteryMaxMv) {
    if (!addPercent) {
      return 100;
    }
    return "100%";
  }

  //check if mv is below min, if so return 0%
  if (mv <= batteryMinMv) {
    if (!addPercent) {
      return 0;
    }
    return "0%";
  }

  //calculate percentage
  let percent = Math.round(
    ((mv - batteryMinMv) / (batteryMaxMv - batteryMinMv)) * 100
  );

  // Final validation
  if (isNaN(percent)) {
    logger.warn("Calculated percentage is NaN:", {
      mv,
      batteryMinMv,
      batteryMaxMv,
    });
    return addPercent ? "N/A" : NaN;
  }

  if (!addPercent) {
    return percent;
  }

  return percent + "%";
}

/**
 * Converts percentage to color
 */
export function convertPercentToColour(percent) {
  if (!percent || percent === "N/A") {
    return "#ccc";
  }

  //remove % sign if it exists
  if (typeof percent === "string") {
    percent = parseInt(percent.replace("%", ""));
  }

  if (percent >= 80) {
    return "#4caf50"; // Green
  } else if (percent >= 60) {
    return "#ff9800"; // Orange
  } else if (percent >= 40) {
    return "#ff5722"; // Red-orange
  } else if (percent >= 20) {
    return "#f44336"; // Red
  } else {
    return "#d32f2f"; // Dark red
  }
}
